<template>
  <v-sheet>
    <h2>Course Registration</h2>
    <v-data-table
      :headers="headers"
      :items="registrationEvents"
      :items-per-page="5"
      dense
      :loading="loading"
      class="mt-2 elevation-2"
    ></v-data-table>
  </v-sheet>
</template>

<script>
import { COURSE_REGISTRATION_QUERY } from "@/constants/graphql/client/registrations"
import { YYYYMMDD_readable } from "@/lib/fancy_date";

export default {
  name: "ClientCourses",
  props: ["userId"],
  data() { 
    return {
      loading: true,
      registrationEvents: [],
      courseRegistrations: {},
      headers: [
        { text: 'Product', value: 'product',},
        { text: 'Course', value: 'course' },
        { text: 'Registration Date', value: 'registrationDate' },
      ],
    }
  },
  methods: {
    formatDate(date) {
      return YYYYMMDD_readable(date);
    },
  },
  apollo: {
    courseRegistrations: {
      query: COURSE_REGISTRATION_QUERY,
      variables() {
        return {
          userId: btoa("UserNode:" + this.userId)
        };
      },
      fetchPolicy: "cache-and-network",
      result(response) {
        if (response.data) {
          this.registrationEvents = response.data.courseRegistrations.edges.map((item) => {
            return {
              product: item.node.product.name,
              course: item.node.course != null ? item.node.course.title : 'No course Selected',  
              registrationDate: this.formatDate(item.node.createdAt)
            } 
          });
          this.loading = false;
        }
      }
    }
  }
}
</script>